import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUser } from '../../store/UserContext';

function AlipayCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useUser();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleAlipayCallback = async () => {
      try {
        // 获取URL参数
        const authCode = searchParams.get('auth_code');
        const state = searchParams.get('state');
        const error = searchParams.get('error');

        if (error) {
          setError('支付宝授权失败: ' + error);
          setLoading(false);
          return;
        }

        if (!authCode) {
          setError('未获取到授权码');
          setLoading(false);
          return;
        }

        // console.log removed
// 调用后端登录接口
        const response = await fetch('/api/users/alipay-login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code: authCode })
        });

        const data = await response.json();

        if (response.ok) {
          if (data.success) {
            // 登录成功
            const userData = data.user;
            if (!userData.tenantId) {
              userData.tenantId = 'default';
            }
            
            localStorage.setItem('token', data.token);
            setUser(userData);
            
            // 跳转到欢迎页面
            navigate('/welcome');
          } else if (data.needBind) {
            // 需要绑定账号，跳转到绑定页面
            navigate('/login', { 
              state: { 
                bindData: data,
                showBindModal: true 
              } 
            });
          }
        } else {
          setError(data.message || '支付宝登录失败');
        }
      } catch (err) {
        console.error('支付宝回调处理失败:', err);
        setError('处理支付宝回调失败: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    handleAlipayCallback();
  }, [searchParams, navigate, setUser]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">正在处理支付宝登录...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="text-red-500 text-xl mb-4">❌</div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">登录失败</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            返回登录页面
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default AlipayCallbackPage; 